import React , {Component} from "react"
import {UncontrolledCarousel} from "reactstrap";
import {Helmet} from "react-helmet";
import Icon1 from "../../assets/Acceuil/Groupe 80.svg"
import Icon2 from "../../assets/Acceuil/Groupe 81.svg"

import Slide1 from "../../assets/Acceuil/ADSIL (1920 x 1184).png"
import Slide2 from "../../assets/Acceuil/Cab by night (1).png"
import Slide3 from "../../assets/Acceuil/Voyageur 04.png"

import FavIcon from "../../assets/FavIcons/03.ico"


import './styles.css'

const EtiqCard =({ borderBottom, img , text}) =>{
    return (
        <div className="etiqCard pt-lg-2 pb-lg-2" style={{ borderBottom : borderBottom ? '2px solid var(--text-color-gray)' : null}}>
            <div style={{ alignItems : 'center'}} className="d-flex">
                <img className="etiqCardImg m-3 m-lg-0" src={img} alt=""/>
                <div  className="etiqCardText ml-3" style={{  textAlign : 'left' , textTransform : "uppercase" }}>{text} </div>
            </div>
        </div>

    )
}

export class Accueil extends Component{
    constructor(props) {
        super(props);
        this.state={
            slides : [
                {
                    src: Slide1,
                    // altText: 'Slide 1',
                    // caption: 'Slide 1',
                    // header: 'Slide 1 Header',
                    key: '1'
                },
                {
                    src : Slide2,
                    // altText: 'Slide 2',
                    // caption: 'Slide 2',
                    // header: 'Slide 2 Header',
                    key: '2'
                },
                {
                    src : Slide3,
                    // altText: 'Slide 3',
                    // caption: 'Slide 3',
                    // header: 'Slide 3 Header',
                    key: '3'
                }
            ]
        }
    }
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title> ADSIL Acceuil</title>
                    <link rel="shortcut icon"  href={FavIcon} />
                </Helmet>
                <div id="etiqContainer">
                    <div className="p-2 p-lg-0 " id="Etiq">
                        <div className="p-2 p-lg-4">
                            <EtiqCard borderBottom={true} img={Icon2} text={'Devenez notre partenaire chauffeur de taxi'}/>
                            <EtiqCard borderBottom={false} img={Icon1} text={'Réservez vos places dès à présent'}/>
                        </div>
                    </div>
                </div>
                <UncontrolledCarousel items={this.state.slides}/>
            </React.Fragment>
        )
    }
}